<template>
  <div class="fill-height">
    <v-container fluid class="container-width">
      <v-card flat>
        <v-tabs v-model="tab" show-arrows fixed-tabs>
          <v-tab v-show="isSigned" key="orders" href="#tab-orders">
            Minhas ordens de serviço
          </v-tab>
          <v-tab key="accredited" href="#tab-accredited">
            Meu Credenciamento
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item v-show="isSigned" key="orders" value="tab-orders">
            <flight-orders />
          </v-tab-item>
          <v-tab-item key="accredited" value="tab-accredited">
            <div class="head px-4 pt-4">
              <p class="title"><strong>SERVIÇOS</strong></p>
              <div v-if="mustShowText">
                <p>
                  Além de fazer o processamento das imagens do seu drone aqui na
                  Mappa, você também pode ser indicado para prestar serviços de
                  mapeamento com drones.
                </p>
                <p class="title"><strong>COMO FUNCIONA?</strong></p>
                <p>
                  A Horus Aeronaves, fundadora da Mappa, recebe demandas mensais
                  para realizar serviços de mapeamento em todo o Brasil.
                  <br />São contratos com grandes corporações, que requerem
                  qualidade e rapidez.
                </p>
                <p>
                  Para atender a essas demandas, a Horus expandiu sua rede de
                  credenciados para prestação de serviço de mapeamento com
                  drones.
                </p>
                <p>
                  Para se cadastrar é simples.
                  <br />
                  Basta preencher os dados a seguir, <u>sem nenhum custo</u>.
                </p>
                <p>
                  A Horus possui grandes contratos de prestação de serviço de
                  mapeamento com drones.
                  <br />A cada semana, novos contratos são fechados.
                </p>
                <p>
                  Nas demandas da sua região e de acordo com o seu perfil, o
                  serviço é repassado para você.
                </p>
                <p>
                  O vínculo de Credenciado é firmado aqui na plataforma Mappa,
                  para repasse dos serviços.
                </p>
                <p>
                  Finalizado o serviço, o pagamento é realizado e você aumenta
                  seu faturamento.
                </p>
                <p>OBS: Não é necessário ter um equipamento Horus.</p>
                <p>
                  Clique em 'INICIAR CADASTRO' e preencha o formulário com as
                  informações corretas e completas para completar e validar seu
                  cadastro:
                </p>
                <v-row class="ma-0 pa-4">
                  <v-spacer />
                  <v-btn color="primary" @click="beginRegister" class="mt-4">
                    INICIAR CADASTRO
                  </v-btn>
                </v-row>
              </div>
            </div>
            <div v-if="mustShowForm" class="px-4 pb-4">
              <v-row align="center" justify="center" class="pa-0 ma-0">
                <v-stepper v-model="step" class="stepper-width">
                  <v-stepper-header>
                    <v-stepper-step :complete="step > 1" step="1"
                      >Passo 1</v-stepper-step
                    >
                    <v-divider></v-divider>
                    <v-stepper-step :complete="step > 2" step="2"
                      >Passo 2</v-stepper-step
                    >
                    <v-divider></v-divider>
                    <v-stepper-step :complete="registered" step="3"
                      >Passo 3</v-stepper-step
                    >
                  </v-stepper-header>

                  <v-stepper-items>
                    <v-stepper-content step="1">
                      <v-card elevation="0">
                        <v-card-text>
                          <v-container fluid class="pa-0">
                            <v-row class="ma-0 pa-0">
                              <v-col
                                cols="12"
                                sm="6"
                                md="3"
                                lg="3"
                                xl="3"
                                class="py-0"
                              >
                                <v-text-field
                                  label="Nome completo"
                                  color="accent"
                                  outlined
                                  v-model="form.name"
                                  :error-messages="nameErrors"
                                  class="mx-0 mt-4"
                                >
                                </v-text-field>
                              </v-col>

                              <v-col
                                cols="12"
                                sm="6"
                                md="3"
                                lg="3"
                                xl="3"
                                class="py-0"
                              >
                                <v-text-field
                                  label="CPF"
                                  color="accent"
                                  outlined
                                  v-mask="cpfMask"
                                  v-model="form.cpf"
                                  class="mx-0 mt-4"
                                  :error-messages="cpfErrors"
                                >
                                </v-text-field>
                              </v-col>
                              <v-col
                                cols="12"
                                sm="6"
                                md="3"
                                lg="3"
                                xl="3"
                                class="py-0"
                              >
                                <v-text-field
                                  label="Data de Nascimento"
                                  color="accent"
                                  outlined
                                  v-model="form.birthdate"
                                  v-mask="birthdateMask"
                                  :error-messages="birthdateErrors"
                                  class="mx-0 mt-4"
                                >
                                </v-text-field>
                              </v-col>
                              <v-col
                                cols="12"
                                sm="6"
                                md="3"
                                lg="3"
                                xl="3"
                                class="py-0"
                              >
                                <v-select
                                  label="Estado civil"
                                  color="accent"
                                  :items="maritalStatusOptions"
                                  outlined
                                  v-model="form.maritalStatus"
                                  :error-messages="maritalStatusErrors"
                                  class="mx-0 mt-4"
                                >
                                </v-select>
                              </v-col>
                            </v-row>
                            <v-row class="ma-0 py-0">
                              <v-col
                                cols="12"
                                sm="6"
                                md="6"
                                lg="6"
                                xl="6"
                                class="py-0"
                              >
                                <v-text-field
                                  label="E-mail corporativo"
                                  color="accent"
                                  outlined
                                  v-model="form.corporateEmail"
                                  :error-messages="corporateEmailErrors"
                                  class="mx-0"
                                >
                                </v-text-field>
                              </v-col>

                              <v-col
                                cols="12"
                                sm="6"
                                md="6"
                                lg="6"
                                xl="6"
                                class="py-0"
                              >
                                <v-text-field
                                  label="Confirmação e-mail corporativo"
                                  color="accent"
                                  outlined
                                  v-model="form.corporateEmailConfirm"
                                  :error-messages="corporateEmailConfirmErrors"
                                  class="mx-0"
                                >
                                </v-text-field>
                              </v-col>
                            </v-row>

                            <v-row class="ma-0 py-0">
                              <v-col
                                cols="12"
                                sm="6"
                                md="6"
                                lg="6"
                                xl="6"
                                class="py-0"
                              >
                                <phone-input
                                  label="Celular com DDD"
                                  color="accent"
                                  outlined
                                  v-model="form.phoneNumber"
                                  :error-messages="phoneNumberErrors"
                                  class="mx-0"
                                >
                                </phone-input>
                              </v-col>

                              <v-col
                                cols="12"
                                sm="6"
                                md="6"
                                lg="6"
                                xl="6"
                                class="py-0"
                              >
                                <phone-input
                                  label="Confirmação celular com DDD"
                                  color="accent"
                                  outlined
                                  v-model="form.phoneNumberConfirm"
                                  :error-messages="phoneNumberConfirmErrors"
                                  class="mx-0"
                                >
                                </phone-input>
                              </v-col>
                            </v-row>
                            <v-row class="ma-0 py-0">
                              <v-col
                                cols="12"
                                sm="6"
                                md="6"
                                lg="6"
                                xl="6"
                                class="py-0"
                              >
                                <v-text-field
                                  label="Nome da empresa"
                                  color="accent"
                                  outlined
                                  v-model="form.companyName"
                                  :error-messages="companyNameErrors"
                                  class="mx-0"
                                >
                                </v-text-field>
                              </v-col>

                              <v-col
                                cols="12"
                                sm="6"
                                md="6"
                                lg="6"
                                xl="6"
                                class="py-0"
                              >
                                <v-text-field
                                  label="CNPJ da empresa"
                                  color="accent"
                                  outlined
                                  v-model="form.cnpj"
                                  v-mask="cnpjMask"
                                  :error-messages="cnpjErrors"
                                  class="mx-0"
                                >
                                </v-text-field>
                              </v-col>
                            </v-row>

                            <v-row class="ma-0 py-0">
                              <v-col
                                cols="12"
                                sm="6"
                                md="6"
                                lg="6"
                                xl="6"
                                class="py-0"
                              >
                                <v-text-field
                                  label="Nome representante legal da empresa"
                                  color="accent"
                                  outlined
                                  v-model="form.companyLegalRepresentativeName"
                                  :error-messages="
                                    companyLegalRepresentativeNameErrors
                                  "
                                  class="mx-0"
                                >
                                </v-text-field>
                              </v-col>

                              <v-col
                                cols="12"
                                sm="6"
                                md="6"
                                lg="6"
                                xl="6"
                                class="py-0"
                              >
                                <v-text-field
                                  label="Site da empresa"
                                  color="accent"
                                  outlined
                                  v-model="form.companySite"
                                  :error-messages="companySiteErrors"
                                  class="mx-0"
                                >
                                </v-text-field>
                              </v-col>
                            </v-row>
                            <v-row class="ma-0 py-0">
                              <v-col
                                cols="12"
                                sm="6"
                                md="3"
                                lg="3"
                                xl="3"
                                class="py-0"
                              >
                                <v-text-field
                                  label="CEP"
                                  color="accent"
                                  outlined
                                  v-model="strZipCode"
                                  v-mask="cepMask"
                                  :error-messages="strZipCodeErrors"
                                  class="mx-0"
                                >
                                </v-text-field>
                              </v-col>

                              <v-col
                                cols="12"
                                sm="6"
                                md="3"
                                lg="3"
                                xl="3"
                                class="py-0"
                              >
                                <v-select
                                  v-show="showAddressFields"
                                  :items="statesList"
                                  label="Estado"
                                  color="accent"
                                  outlined
                                  v-model="form.state"
                                  :error-messages="stateErrors"
                                  class="mx-0"
                                >
                                </v-select>
                              </v-col>

                              <v-col
                                cols="12"
                                sm="6"
                                md="3"
                                lg="3"
                                xl="3"
                                class="py-0"
                              >
                                <v-text-field
                                  v-show="showAddressFields"
                                  label="Cidade"
                                  color="accent"
                                  outlined
                                  v-model="form.city"
                                  :error-messages="cityErrors"
                                  class="mx-0"
                                >
                                </v-text-field>
                              </v-col>
                              <v-col
                                cols="12"
                                sm="6"
                                md="3"
                                lg="3"
                                xl="3"
                                class="py-0"
                              >
                                <v-text-field
                                  v-show="showAddressFields"
                                  label="Bairro"
                                  color="accent"
                                  outlined
                                  v-model="form.district"
                                  :error-messages="districtErrors"
                                  class="mx-0"
                                >
                                </v-text-field>
                              </v-col>
                            </v-row>

                            <v-row class="ma-0 py-0">
                              <v-col
                                cols="12"
                                sm="6"
                                md="6"
                                lg="6"
                                xl="6"
                                class="py-0"
                              >
                                <v-text-field
                                  v-show="showAddressFields"
                                  label="Rua"
                                  color="accent"
                                  outlined
                                  v-model="form.street"
                                  :error-messages="streetErrors"
                                  class="mx-0"
                                >
                                </v-text-field>
                              </v-col>

                              <v-col
                                cols="12"
                                sm="3"
                                md="3"
                                lg="3"
                                xl="3"
                                class="py-0"
                              >
                                <v-text-field
                                  v-show="showAddressFields"
                                  label="Número"
                                  color="accent"
                                  outlined
                                  v-model="form.addressNumber"
                                  :error-messages="addressNumberErrors"
                                  class="mx-0"
                                >
                                </v-text-field>
                              </v-col>
                              <v-col
                                cols="12"
                                sm="3"
                                md="3"
                                lg="3"
                                xl="3"
                                class="py-0"
                              >
                                <v-text-field
                                  v-show="showAddressFields"
                                  label="Complemento"
                                  color="accent"
                                  outlined
                                  v-model="form.complement"
                                  class="mx-0"
                                >
                                </v-text-field>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                      </v-card>

                      <v-row justify="end" class="my-0 mr-6">
                        <v-btn color="primary" @click="nextFirstStep">
                          Próximo
                        </v-btn>
                      </v-row>
                    </v-stepper-content>

                    <v-stepper-content step="2">
                      <v-card elevation="0">
                        <v-card-text>
                          <v-container fluid class="pa-0">
                            <v-row class="ma-0 py-0">
                              <v-col
                                cols="12"
                                sm="6"
                                md="6"
                                lg="6"
                                xl="6"
                                class="py-0"
                              >
                                <v-select
                                  label="Tempo no mercado de mapeamento aéreo com drone"
                                  color="accent"
                                  outlined
                                  :items="aerialMappingExperienceOptions"
                                  v-model="form.aerialMappingExperience"
                                  class="mx-0"
                                  :error-messages="
                                    aerialMappingExperienceErrors
                                  "
                                >
                                </v-select>
                              </v-col>

                              <v-col
                                cols="12"
                                sm="6"
                                md="6"
                                lg="6"
                                xl="6"
                                class="py-0"
                              >
                                <v-select
                                  label="Em quais áreas já realizou mapeamento"
                                  color="accent"
                                  outlined
                                  attach
                                  chips
                                  multiple
                                  :items="mappingSectorsOptions"
                                  v-model="form.mappingSectors"
                                  :error-messages="mappingSectorsErrors"
                                  class="mx-0"
                                >
                                </v-select>
                              </v-col>
                            </v-row>

                            <v-row class="ma-0 py-0">
                              <v-col
                                cols="12"
                                sm="6"
                                md="6"
                                lg="6"
                                xl="6"
                                class="py-0"
                              >
                                <v-select
                                  label="Possui habilitação técnica para trabalhos de agrimensura e topografia?"
                                  color="accent"
                                  outlined
                                  :items="booleanList"
                                  v-model="
                                    form.hasTechinicalQualificationSurveyingTopography
                                  "
                                  :error-messages="
                                    hasTechinicalQualificationSurveyingTopographyErrors
                                  "
                                  class="mx-0"
                                >
                                </v-select>
                              </v-col>

                              <v-col
                                cols="12"
                                sm="6"
                                md="6"
                                lg="6"
                                xl="6"
                                class="py-0"
                              >
                                <v-select
                                  label="Emite ART?"
                                  color="accent"
                                  outlined
                                  :items="booleanList"
                                  v-model="form.issueArt"
                                  :error-messages="issueArtErrors"
                                  class="mx-0"
                                >
                                </v-select>
                              </v-col>
                            </v-row>

                            <v-row class="ma-0 py-0">
                              <v-col
                                cols="12"
                                sm="6"
                                md="6"
                                lg="6"
                                xl="6"
                                class="py-0"
                              >
                                <v-select
                                  label="Possui experiência em realizar pontos de controle em solo?"
                                  color="accent"
                                  outlined
                                  :items="booleanList"
                                  v-model="form.hasGcpExperience"
                                  :error-messages="hasGcpExperienceErrors"
                                  class="mx-0"
                                >
                                </v-select>
                              </v-col>

                              <v-col
                                cols="12"
                                sm="6"
                                md="6"
                                lg="6"
                                xl="6"
                                class="py-0"
                              >
                                <v-select
                                  label="Possui equipamentos gps ou rtk?"
                                  color="accent"
                                  outlined
                                  :items="booleanList"
                                  v-model="form.hasGpsRtk"
                                  :error-messages="hasGpsRtkErrors"
                                  class="mx-0"
                                >
                                </v-select>
                              </v-col>
                            </v-row>

                            <v-row class="ma-0 py-0">
                              <v-col
                                cols="12"
                                sm="6"
                                md="6"
                                lg="6"
                                xl="6"
                                class="py-0"
                              >
                                <v-select
                                  label="Possui drone multirotor?"
                                  color="accent"
                                  outlined
                                  :items="booleanList"
                                  v-model="form.hasMultirotorDrone"
                                  :error-messages="hasMultirotorDroneErrors"
                                  class="mx-0"
                                >
                                </v-select>
                              </v-col>

                              <v-col
                                cols="12"
                                sm="6"
                                md="6"
                                lg="6"
                                xl="6"
                                class="py-0"
                              >
                                <v-select
                                  v-show="form.hasMultirotorDrone"
                                  label="Qual(is) modelo(s) de multirotor?"
                                  color="accent"
                                  outlined
                                  attach
                                  chips
                                  multiple
                                  :items="droneModelsOptions"
                                  v-model="form.multirotorDroneModels"
                                  :error-messages="multirotorDroneModelsErrors"
                                  class="mx-0"
                                >
                                </v-select>
                              </v-col>
                            </v-row>

                            <v-row class="ma-0 py-0">
                              <v-col
                                cols="12"
                                sm="6"
                                md="6"
                                lg="6"
                                xl="6"
                                class="py-0"
                              >
                                <v-select
                                  label="Possui drone asa fixa?"
                                  color="accent"
                                  outlined
                                  :items="booleanList"
                                  v-model="form.hasFixedWingsDrone"
                                  :error-messages="hasFixedWingsDroneErrors"
                                  class="mx-0"
                                >
                                </v-select>
                              </v-col>

                              <v-col
                                cols="12"
                                sm="6"
                                md="6"
                                lg="6"
                                xl="6"
                                class="py-0"
                              >
                                <v-text-field
                                  v-show="form.hasFixedWingsDrone"
                                  label="Qual(is) modelo(s) de asa fixa?"
                                  color="accent"
                                  outlined
                                  v-model="form.fixedWingsDroneModels"
                                  :error-messages="fixedWingsDroneModelsErrors"
                                  class="mx-0"
                                >
                                </v-text-field>
                              </v-col>
                            </v-row>

                            <v-row class="ma-0 py-0">
                              <v-col
                                cols="12"
                                sm="6"
                                md="6"
                                lg="6"
                                xl="6"
                                class="py-0"
                              >
                                <v-select
                                  label="Possui câmera multiespectral?"
                                  color="accent"
                                  outlined
                                  :items="booleanList"
                                  v-model="form.hasMultispectralCamera"
                                  :error-messages="hasMultispectralCameraErrors"
                                  class="mx-0"
                                >
                                </v-select>
                              </v-col>

                              <v-col
                                cols="12"
                                sm="6"
                                md="6"
                                lg="6"
                                xl="6"
                                class="py-0"
                              >
                                <v-text-field
                                  v-show="form.hasMultispectralCamera"
                                  label="Qual(is) modelo(s) de câmera multiespectral?"
                                  color="accent"
                                  outlined
                                  v-model="form.multispectralCameraModels"
                                  :error-messages="
                                    multispectralCameraModelsErrors
                                  "
                                  class="mx-0"
                                >
                                </v-text-field>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                      </v-card>

                      <v-row justify="space-between" class="my-0 mx-6">
                        <v-btn text color="primary" @click="backSecondStep">
                          Voltar
                        </v-btn>
                        <v-btn
                          color="primary"
                          @click="nextSecondStep"
                          class="mb-7"
                        >
                          Próximo
                        </v-btn>
                      </v-row>
                    </v-stepper-content>

                    <v-stepper-content step="3">
                      <v-card elevation="0">
                        <v-card-text>
                          <v-container fluid class="pa-0">
                            <v-row class="ma-0 py-0">
                              <v-col
                                cols="12"
                                sm="6"
                                md="6"
                                lg="6"
                                xl="6"
                                class="py-0"
                              >
                                <v-select
                                  label="Possui seguro contra terceiros obrigatório para seus drones?"
                                  color="accent"
                                  outlined
                                  :items="booleanList"
                                  v-model="form.hasMandatoryInsurance"
                                  :error-messages="hasMandatoryInsuranceErrors"
                                  class="mx-0"
                                >
                                </v-select>
                              </v-col>

                              <v-col
                                cols="12"
                                sm="6"
                                md="6"
                                lg="6"
                                xl="6"
                                class="py-0"
                              >
                                <v-select
                                  label="Possui registro da anac em seus drones?"
                                  color="accent"
                                  outlined
                                  :items="booleanList"
                                  v-model="form.hasAnacRegister"
                                  :error-messages="hasAnacRegisterErrors"
                                  class="mx-0"
                                >
                                </v-select>
                              </v-col>
                            </v-row>

                            <v-row class="ma-0 py-0">
                              <v-col
                                cols="12"
                                sm="6"
                                md="6"
                                lg="6"
                                xl="6"
                                class="py-0"
                              >
                                <v-select
                                  label="Possui homologação da anatel em todos seus drones?"
                                  color="accent"
                                  outlined
                                  :items="booleanList"
                                  v-model="form.hasAnatelHomologation"
                                  :error-messages="hasAnatelHomologationErrors"
                                  class="mx-0"
                                >
                                </v-select>
                              </v-col>

                              <v-col
                                cols="12"
                                sm="6"
                                md="6"
                                lg="6"
                                xl="6"
                                class="py-0"
                              >
                                <v-select
                                  label="Possui cadastro na Mappa?"
                                  color="accent"
                                  outlined
                                  :items="booleanList"
                                  v-model="form.hasMappaRegister"
                                  :error-messages="hasMappaRegisterErrors"
                                  class="mx-0"
                                >
                                </v-select>
                              </v-col>
                            </v-row>

                            <v-row class="ma-0 py-0 my-0">
                              <v-col
                                cols="12"
                                sm="6"
                                md="6"
                                lg="6"
                                xl="6"
                                class="py-0 my-0"
                              >
                                <v-select
                                  label="Possui cadastro na plataforma do sarpas do decea?"
                                  color="accent"
                                  outlined
                                  :items="booleanList"
                                  v-model="form.hasSarpasRegisterOnDecea"
                                  :error-messages="
                                    hasSarpasRegisterOnDeceaErrors
                                  "
                                  class="mx-0 my-0"
                                >
                                </v-select>
                              </v-col>
                              <v-col
                                cols="12"
                                sm="6"
                                md="6"
                                lg="6"
                                xl="6"
                                class="py-0 my-0"
                              >
                                <v-text-field
                                  v-show="form.hasSarpasRegisterOnDecea"
                                  label="Número registro do sarpas para solicitação de voos no decea"
                                  color="accent"
                                  outlined
                                  v-model="form.sarpasRegisterNumberOnDecea"
                                  :error-messages="
                                    sarpasRegisterNumberOnDeceaErrors
                                  "
                                  class="mx-0 my-0"
                                >
                                </v-text-field>
                              </v-col>
                            </v-row>
                            <v-row class="ma-0 py-0">
                              <v-col
                                cols="12"
                                sm="12"
                                md="12"
                                lg="12"
                                xl="12"
                                class="py-0 my-0"
                              >
                                <v-checkbox
                                  color="accent"
                                  v-model="form.truthDeclaration"
                                  class="mx-0 my-0 py-0"
                                  messages="DECLARO QUE AS INFORMAÇÕES SÃO VERDADEIRAS E ASSUMO A INTEIRA RESPONSABILIDADE PELAS MESMAS."
                                >
                                </v-checkbox>
                              </v-col>
                            </v-row>
                            <v-row class="ma-0">
                              <v-col
                                cols="12"
                                sm="12"
                                md="12"
                                lg="12"
                                xl="12"
                                class="politics px-3 mt-2"
                              >
                                <!-- BEGIN: MODAL TERMOS DE USO -->
                                <v-dialog v-model="dialog" width="600px">
                                  <template v-slot:activator="{ on, attrs }">
                                    <span class="caption"
                                      >AO REALIZAR O CREDENCIAMENTO, VOCÊ INDICA QUE
                                      ESTÁ DE ACORDO COM OS NOSSOS
                                      <a 
                                        v-bind="attrs"
                                        v-on="on"
                                      >TERMOS DE USO</a>
                                    </span>                                    
                                    <!-- <v-btn
                                      color="primary"
                                      dark
                                      v-bind="attrs"
                                      v-on="on"
                                    >
                                      Open Dialog
                                    </v-btn> -->
                                  </template>
                                  <v-card >
                                    <v-card-title>
                                      <span class="text-h5"
                                        >Termos de uso</span
                                      >
                                    </v-card-title>
                                    <v-card-text>
                                      <iframe id="dialog-term" v-if="iFrameUrl != ''" class="doc" :src="iFrameUrl" frameborder="0"></iframe> 
                                    </v-card-text>
                                    <v-card-actions>
                                      <v-spacer></v-spacer>
                                      <v-btn
                                        color="green darken-1"
                                        text
                                        @click="dialog = false"
                                      >
                                        FECHAR
                                      </v-btn>
                                    </v-card-actions>
                                  </v-card>
                                </v-dialog>
                                <!-- END: MODAL TERMOS DE USO -->
                                <!-- <span class="caption"
                                  >AO REALIZAR O CREDENCIAMENTO, VOCÊ INDICA QUE
                                  ESTÁ DE ACORDO COM OS NOSSOS
                                  <router-link
                                    to="/accredited-terms-use"
                                    target="_blank"
                                  >
                                    TERMOS DE USO</router-link
                                  >
                                </span> -->
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                      </v-card>
                      <v-row justify="space-between" class="my-0 mx-6">
                        <v-btn text @click="backThirdStep"> Voltar </v-btn>
                        <v-btn
                          color="primary"
                          :loading="isLoadingButton"
                          :disabled="isLoadingButton || !form.truthDeclaration"
                          @click="createFlightProvider"
                        >
                          {{ buttonText }}
                        </v-btn>
                      </v-row>
                    </v-stepper-content>
                  </v-stepper-items>
                </v-stepper>
              </v-row>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import PhoneInput from "../../components/Helpers/Form/PhoneInput";
import PhoneNumber from "awesome-phonenumber";
import { validationMixin } from "vuelidate";
import { email } from "vuelidate/lib/validators";
import { BOOLEAN_LIST } from "../../helpers/flight-provider/constants";
import { STATES } from "../../helpers/payment/constants";
import {
  SET_NAME,
  SET_BIRTHDATE,
  SET_EMAIL,
  SET_CPF,
  SET_UUID_DOCUMENT,
  SET_KEY_SIGNER,
} from "../../store/modules/flight-provider";
import { isEmpty, isNull } from "lodash/lang";
import { unmask } from "../../helpers/utils";
import { debounce } from "lodash/function";
import axios from "axios";
import { NOTIFICATION_TYPES, NotificationOptions } from "../../helpers/notify";
import { lt, eq } from "lodash/lang";
import {
  createFlightProvider,
  listFlightProvider,
  updateFlightProvider,
} from "../../api/api-flight-provider";
import moment from "moment";
import { mapActions } from "vuex";
import FlightOrders from "../../components/FlightProvider/FlightOrders";

const VIACEP_URL = "https://viacep.com.br/ws/";

export default {
  name: "AccreditedRegister",
  components: { FlightOrders, PhoneInput },
  mixins: [validationMixin],
  data: () => ({
    tab: "tab-accredited",
    dialog: false,
    form: {
      name: null,
      cpf: null,
      birthdate: null,
      corporateEmail: null,
      corporateEmailConfirm: null,
      phoneNumber: null,
      phoneNumberConfirm: null,
      companyName: null,
      cnpj: null,
      companyLegalRepresentativeName: null,
      companySite: null,
      cep: null,
      state: null,
      city: null,
      street: null,
      complement: "",
      aerialMappingExperience: null,
      mappingSectors: null,
      hasTechinicalQualificationSurveyingTopography: null,
      issueArt: null,
      hasGcpExperience: null,
      hasGpsRtk: null,
      hasFixedWingsDrone: null,
      fixedWingsDroneModels: null,
      hasMultirotorDrone: null,
      multirotorDroneModels: null,
      hasMultispectralCamera: null,
      multispectralCameraModels: null,
      hasMandatoryInsurance: null,
      hasAnacRegister: null,
      hasAnatelHomologation: null,
      hasSarpasRegisterOnDecea: null,
      sarpasRegisterNumberOnDecea: null,
      hasMappaRegister: null,
      addressNumber: null,
      district: null,
      maritalStatus: null,
    },
    id: null,
    status: null,
    cd_document: null,
    cd_key_signer: null,
    isLoadingButton: false,
    truthDeclaration: false,
    termsUse: false,
    strZipCode: null,
    hasZipCodeError: false,
    isLoadingAddress: false,
    showAddressFields: false,
    step: 1,
    registered: false,
    signatureDialog: false,
    aerialMappingExperienceOptions: [
      "Estou começando agora",
      "Menos de 1 ano",
      "Entre 1 e 2 anos",
      "Mais de 2 anos",
    ],
    mappingSectorsOptions: [
      "Agricultura",
      "Indústria",
      "Topografia",
      "Construção civil",
      "Linhas de transmissão",
      "Rodovias",
      "Georreferenciamento",
      "Monitoramento ambiental",
    ],
    droneModelsOptions: [
      "Mavic Air",
      "Mavic Pro",
      "Mavic 2 Pro",
      "Mavic Zoom",
      "Phantom 3",
      "Phantom 4",
      "Inspire",
      "Anafi",
    ],
    maritalStatusOptions: [
      "Solteiro(a)",
      "Casado(a)",
      "Separado(a)",
      "Divorciado(a)",
      "Viúvo(a)",
    ],
    iFrameUrl: "https://docs.google.com/viewer?url=https://horus-platform.s3.amazonaws.com/mappa_resources/documents/TERMOS_DE_USO_CREDENCIAMENTO_JUN21.doc&embedded=true"
  }),
  validations: {
    form: {
      name: {
        required: function () {
          return !(this.step === 1 && !this.form.name);
        },
      },
      cpf: {
        required: function () {
          return !(this.step === 1 && !this.form.cpf);
        },
      },
      birthdate: {
        required: function () {
          return !(this.step === 1 && !this.form.birthdate);
        },
      },
      corporateEmail: {
        required: function () {
          return !(this.step === 1 && !this.form.corporateEmail);
        },
        email,
      },
      corporateEmailConfirm: {
        required: function () {
          return !(this.step === 1 && !this.form.corporateEmailConfirm);
        },
        corporateEmailMatch() {
          return this.form.corporateEmail === this.form.corporateEmailConfirm;
        },
      },
      phoneNumber: {
        required: function () {
          return !(this.step === 1 && !this.form.phoneNumber);
        },
        isValid: function () {
          if (!this.form.phoneNumber) return false;
          return this.form.phoneNumber.isValid();
        },
      },
      phoneNumberConfirm: {
        required: function () {
          return !(this.step === 1 && !this.form.phoneNumberConfirm);
        },
        isValid: function () {
          if (!this.form.phoneNumber) return false;
          return this.form.phoneNumber.isValid();
        },
        phoneNumberMatch() {
          if (isEmpty(this.form.phoneNumber)) return false;

          return (
            this.form.phoneNumber.getNumber() ===
            this.form.phoneNumberConfirm.getNumber()
          );
        },
      },
      companyName: {
        required: function () {
          return !(this.step === 1 && !this.form.companyName);
        },
      },
      cnpj: {
        required: function () {
          return !(this.step === 1 && !this.form.cnpj);
        },
      },
      companyLegalRepresentativeName: {
        required: function () {
          return !(
            this.step === 1 && !this.form.companyLegalRepresentativeName
          );
        },
      },
      companySite: {
        required: function () {
          return !(this.step === 1 && !this.form.companySite);
        },
      },
      state: {
        required: function () {
          return !(this.step === 1 && !this.form.state);
        },
      },
      city: {
        required: function () {
          return !(this.step === 1 && !this.form.city);
        },
      },
      street: {
        required: function () {
          return !(this.step === 1 && !this.form.street);
        },
      },
      aerialMappingExperience: {
        required: function () {
          return !(this.step === 2 && !this.form.aerialMappingExperience);
        },
      },
      mappingSectors: {
        required: function () {
          return !(this.step === 2 && !this.form.mappingSectors);
        },
      },
      hasTechinicalQualificationSurveyingTopography: {
        required: function () {
          return !(
            this.step === 2 &&
            isNull(this.form.hasTechinicalQualificationSurveyingTopography)
          );
        },
      },
      issueArt: {
        required: function () {
          return !(this.step === 2 && isNull(this.form.issueArt));
        },
      },
      hasGcpExperience: {
        required: function () {
          return !(this.step === 2 && isNull(this.form.hasGcpExperience));
        },
      },
      hasGpsRtk: {
        required: function () {
          return !(this.step === 2 && isNull(this.form.hasGpsRtk));
        },
      },
      hasFixedWingsDrone: {
        required: function () {
          return !(this.step === 2 && isNull(this.form.hasFixedWingsDrone));
        },
      },
      fixedWingsDroneModels: {
        required: function () {
          if (!this.form.hasFixedWingsDrone) return true;
          return !(this.step === 2 && isEmpty(this.form.fixedWingsDroneModels));
        },
      },
      hasMultirotorDrone: {
        required: function () {
          return !(this.step === 2 && isNull(this.form.hasMultirotorDrone));
        },
      },
      multirotorDroneModels: {
        required: function () {
          if (!this.form.hasMultirotorDrone) return true;
          return !(this.step === 2 && isEmpty(this.form.multirotorDroneModels));
        },
      },
      hasMultispectralCamera: {
        required: function () {
          return !(this.step === 2 && isNull(this.form.hasMultispectralCamera));
        },
      },
      multispectralCameraModels: {
        required: function () {
          if (!this.form.hasMultispectralCamera) return true;
          return !(
            this.step === 2 && isEmpty(this.form.multispectralCameraModels)
          );
        },
      },
      hasMandatoryInsurance: {
        required: function () {
          return !(this.step === 3 && isNull(this.form.hasMandatoryInsurance));
        },
      },
      hasAnacRegister: {
        required: function () {
          return !(this.step === 3 && isNull(this.form.hasAnacRegister));
        },
      },
      hasAnatelHomologation: {
        required: function () {
          return !(this.step === 3 && isNull(this.form.hasAnatelHomologation));
        },
      },
      hasSarpasRegisterOnDecea: {
        required: function () {
          return !(
            this.step === 3 && isNull(this.form.hasSarpasRegisterOnDecea)
          );
        },
      },
      sarpasRegisterNumberOnDecea: {
        required: function () {
          if (!this.form.hasSarpasRegisterOnDecea) return true;
          return !(
            this.step === 3 && isNull(this.form.sarpasRegisterNumberOnDecea)
          );
        },
      },
      hasMappaRegister: {
        required: function () {
          return !(this.step === 3 && isNull(this.form.hasMappaRegister));
        },
      },
      addressNumber: {
        required: function () {
          return !(this.step === 1 && isNull(this.form.addressNumber));
        },
      },
      district: {
        required: function () {
          return !(this.step === 1 && !this.form.district);
        },
      },
      maritalStatus: {
        required: function () {
          return !(this.step === 1 && !this.form.maritalStatus);
        },
      },
    },
    strZipCode: {
      required: function () {
        return !(this.step === 1 && !this.strZipCode);
      },
      isValid: function () {
        return !this.hasZipCodeError;
      },
    },
  },
  methods: {
    createFlightProvider() {
      this.isLoadingButton = true;

      let flightProviderData = {
        str_name: this.form.name,
        str_cpf: this.form.cpf,
        dh_birthdate: moment(this.form.birthdate, "DD/MM/YYYY")
          .toISOString()
          .split("T")[0],
        str_corporate_email: this.form.corporateEmail,
        str_phone_number: this.form.phoneNumber.getNumber(),
        str_company_name: this.form.companyName,
        str_cnpj: this.form.cnpj,
        str_company_legal_representative_name:
          this.form.companyLegalRepresentativeName,
        str_company_site: this.form.companySite,
        str_cep: this.strZipCode,
        str_state: this.form.state,
        str_city: this.form.city,
        str_street: this.form.street,
        str_complement: this.form.complement,
        str_aerial_mapping_experience: this.form.aerialMappingExperience,
        lst_mapping_sectors: this.form.mappingSectors,
        bl_has_technical_qualification_surveying_topography:
          this.form.hasTechinicalQualificationSurveyingTopography,
        bl_issue_art: this.form.issueArt,
        bl_has_gcp_experience: this.form.hasGcpExperience,
        bl_has_gps_rtk: this.form.hasGpsRtk,
        bl_has_fixed_wings_drone: this.form.hasFixedWingsDrone,
        str_fixed_wings_drone_models: this.form.fixedWingsDroneModels,
        bl_has_multirotor_drone: this.form.hasMultirotorDrone,
        lst_multirotor_drone_models: this.form.multirotorDroneModels,
        bl_has_multispectral_camera: this.form.hasMultispectralCamera,
        str_multispectral_camera_models: this.form.multispectralCameraModels,
        bl_has_mandatory_insurance: this.form.hasMandatoryInsurance,
        bl_has_anac_register: this.form.hasAnacRegister,
        bl_has_anatel_homologation: this.form.hasAnatelHomologation,
        bl_has_sarpas_register_on_decea: this.form.hasSarpasRegisterOnDecea,
        str_sarpas_register_number_on_decea:
          this.form.sarpasRegisterNumberOnDecea,
        bl_has_mappa_register: this.form.hasMappaRegister,
        str_district: this.form.district,
        str_address_number: this.form.addressNumber,
        str_marital_status: this.form.maritalStatus,
      };

      if (this.status === "SIGNED") {
        flightProviderData.str_cpf = unmask(this.form.cpf, this.cpfMask);
        flightProviderData.str_cnpj = unmask(this.form.cnpj, this.cnpjMask);
        flightProviderData.str_cep = unmask(this.strZipCode, this.cepMask);
        flightProviderData.str_phone_number = this.form.phoneNumber
          .getNumber()
          .slice(3);

        updateFlightProvider(
          this.$apiAuth.getAuthToken(),
          this.id,
          flightProviderData
        )
          .then(() => {
            this.isLoadingButton = false;
          })
          .finally(() => {
            this.isLoadingButton = false;
          });
      } else {
        createFlightProvider(this.$apiAuth.getAuthToken(), flightProviderData)
          .then((resp) => {
            this.setName(resp.data.data.str_name);
            this.setEmail(resp.data.data.str_corporate_email);
            this.setBirthDate(resp.data.data.dh_birthdate);
            this.setCpf(resp.data.data.str_cpf);
            this.setUuidDoc(resp.data.data.cd_document);
            this.setKeySigner(resp.data.data.cd_key_signer);
            this.$router.push("/app/accreditation-signature");
          })
          .finally(() => {
            this.isLoadingButton = false;
          });
      }
    },
    beginRegister() {
      this.status = "BEGIN_REGISTER";
    },
    nextFirstStep() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.$v.$reset();
      this.step = 2;
    },
    backSecondStep() {
      this.step = 1;
    },
    nextSecondStep() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      this.$v.$reset();
      this.step = 3;
    },
    backThirdStep() {
      this.step = 2;
    },
    getAddress: debounce(function () {
      if (!this.strZipCode) return;
      const unmaskedStrZipCode = unmask(this.strZipCode, this.cepMask);
      if (lt(unmaskedStrZipCode.length, 8)) return;

      this.isLoadingAddress = true;
      let requestUrl = `${VIACEP_URL}${unmaskedStrZipCode}/json`;
      axios
        .get(requestUrl)
        .then((res) => {
          const address = res.data;
          if ("erro" in address) {
            this.$notify(
              new NotificationOptions({
                message: "CEP Inválido",
                type: NOTIFICATION_TYPES.ERROR,
              })
            );
            this.hasZipCodeError = true;
            return;
          }

          this.hasZipCodeError = false;
          this.showAddressFields = true;

          this.form.street = address["logradouro"];
          this.form.district = address["bairro"];
          this.form.city = address["localidade"];
          this.form.state = address["uf"];
        })
        .finally(() => {
          this.isLoadingAddress = false;
        });
    }, 500),

    ...mapActions({
      setName: SET_NAME,
      setEmail: SET_EMAIL,
      setBirthDate: SET_BIRTHDATE,
      setCpf: SET_CPF,
      setUuidDoc: SET_UUID_DOCUMENT,
      setKeySigner: SET_KEY_SIGNER,
    }),
  },
  computed: {
    statesList() {
      return STATES;
    },
    booleanList() {
      return BOOLEAN_LIST;
    },
    cpfMask() {
      return ["###.###.###-##"];
    },
    birthdateMask() {
      return ["##/##/####"];
    },
    cnpjMask() {
      return ["##.###.###/####-##"];
    },
    cepMask() {
      return ["#####-###"];
    },
    buttonText() {
      return this.status === "SIGNED" ? "Salvar" : "Credenciar";
    },
    mustShowText() {
      return !this.status;
    },
    mustShowForm() {
      return !!this.status;
    },
    isSigned() {
      if (!this.status) return false;
      return this.status === "SIGNED";
    },

    // Validation errors
    nameErrors() {
      const errors = [];
      if (!this.$v.form.name.$dirty) return errors;
      !this.$v.form.name.required && errors.push("Campo obrigatório");
      return errors;
    },
    cpfErrors() {
      const errors = [];
      if (!this.$v.form.cpf.$dirty) return errors;
      !this.$v.form.cpf.required && errors.push("Campo obrigatório");
      return errors;
    },
    birthdateErrors() {
      const errors = [];
      if (!this.$v.form.birthdate.$dirty) return errors;
      !this.$v.form.birthdate.required && errors.push("Campo obrigatório");
      return errors;
    },
    corporateEmailErrors() {
      const errors = [];
      if (!this.$v.form.corporateEmail.$dirty) return errors;
      !this.$v.form.corporateEmail.required && errors.push("Campo obrigatório");
      !this.$v.form.corporateEmail.email && errors.push("E-mail inválido");
      return errors;
    },
    corporateEmailConfirmErrors() {
      const errors = [];
      if (!this.$v.form.corporateEmailConfirm.$dirty) return errors;
      !this.$v.form.corporateEmailConfirm.required &&
        errors.push("Campo obrigatório");
      !this.$v.form.corporateEmailConfirm.corporateEmailMatch &&
        errors.push("Os e-mails fornecidos devem ser o mesmo.");
      return errors;
    },
    phoneNumberErrors() {
      const errors = [];
      if (!this.$v.form.phoneNumber.$dirty) return errors;
      !this.$v.form.phoneNumber.required && errors.push("Campo obrigatório");
      !this.$v.form.phoneNumber.isValid && errors.push("Telefone inválido");
      return errors;
    },
    phoneNumberConfirmErrors() {
      const errors = [];
      if (!this.$v.form.phoneNumberConfirm.$dirty) return errors;
      !this.$v.form.phoneNumberConfirm.required &&
        errors.push("Campo obrigatório");
      !this.$v.form.phoneNumberConfirm.isValid &&
        errors.push("Telefone inválido");
      !this.$v.form.phoneNumberConfirm.phoneNumberMatch &&
        errors.push("Os celulares com ddd fornecidos devem ser o mesmo");
      return errors;
    },
    companyNameErrors() {
      const errors = [];
      if (!this.$v.form.companyName.$dirty) return errors;
      !this.$v.form.companyName.required && errors.push("Campo obrigatório");
      return errors;
    },
    cnpjErrors() {
      const errors = [];
      if (!this.$v.form.cnpj.$dirty) return errors;
      !this.$v.form.cnpj.required && errors.push("Campo obrigatório");
      return errors;
    },
    companyLegalRepresentativeNameErrors() {
      const errors = [];
      if (!this.$v.form.companyLegalRepresentativeName.$dirty) return errors;
      !this.$v.form.companyLegalRepresentativeName.required &&
        errors.push("Campo obrigatório");
      return errors;
    },
    companySiteErrors() {
      const errors = [];
      if (!this.$v.form.companySite.$dirty) return errors;
      !this.$v.form.companySite.required && errors.push("Campo obrigatório");
      return errors;
    },
    strZipCodeErrors() {
      const errors = [];
      if (!this.$v.strZipCode.$dirty) return errors;
      !this.$v.strZipCode.required && errors.push("Campo obrigatório");
      return errors;
    },
    stateErrors() {
      const errors = [];
      if (!this.$v.form.state.$dirty) return errors;
      !this.$v.form.state.required && errors.push("Campo obrigatório");
      return errors;
    },
    cityErrors() {
      const errors = [];
      if (!this.$v.form.city.$dirty) return errors;
      !this.$v.form.city.required && errors.push("Campo obrigatório");
      return errors;
    },
    streetErrors() {
      const errors = [];
      if (!this.$v.form.street.$dirty) return errors;
      !this.$v.form.street.required && errors.push("Campo obrigatório");
      return errors;
    },
    aerialMappingExperienceErrors() {
      const errors = [];
      if (!this.$v.form.aerialMappingExperience.$dirty) return errors;
      !this.$v.form.aerialMappingExperience.required &&
        errors.push("Campo obrigatório");
      return errors;
    },
    mappingSectorsErrors() {
      const errors = [];
      if (!this.$v.form.mappingSectors.$dirty) return errors;
      !this.$v.form.mappingSectors.required && errors.push("Campo obrigatório");
      return errors;
    },
    hasTechinicalQualificationSurveyingTopographyErrors() {
      const errors = [];
      if (!this.$v.form.hasTechinicalQualificationSurveyingTopography.$dirty)
        return errors;
      !this.$v.form.hasTechinicalQualificationSurveyingTopography.required &&
        errors.push("Campo obrigatório");
      return errors;
    },
    issueArtErrors() {
      const errors = [];
      if (!this.$v.form.issueArt.$dirty) return errors;
      !this.$v.form.issueArt.required && errors.push("Campo obrigatório");
      return errors;
    },
    hasGcpExperienceErrors() {
      const errors = [];
      if (!this.$v.form.hasGcpExperience.$dirty) return errors;
      !this.$v.form.hasGcpExperience.required &&
        errors.push("Campo obrigatório");
      return errors;
    },
    hasGpsRtkErrors() {
      const errors = [];
      if (!this.$v.form.hasGpsRtk.$dirty) return errors;
      !this.$v.form.hasGpsRtk.required && errors.push("Campo obrigatório");
      return errors;
    },
    hasFixedWingsDroneErrors() {
      const errors = [];
      if (!this.$v.form.hasFixedWingsDrone.$dirty) return errors;
      !this.$v.form.hasFixedWingsDrone.required &&
        errors.push("Campo obrigatório");
      return errors;
    },
    fixedWingsDroneModelsErrors() {
      const errors = [];
      if (!this.$v.form.fixedWingsDroneModels.$dirty) return errors;
      !this.$v.form.fixedWingsDroneModels.required &&
        errors.push("Campo obrigatório");
      return errors;
    },
    hasMultirotorDroneErrors() {
      const errors = [];
      if (!this.$v.form.hasMultirotorDrone.$dirty) return errors;
      !this.$v.form.hasMultirotorDrone.required &&
        errors.push("Campo obrigatório");
      return errors;
    },
    multirotorDroneModelsErrors() {
      const errors = [];
      if (!this.$v.form.multirotorDroneModels.$dirty) return errors;
      !this.$v.form.multirotorDroneModels.required &&
        errors.push("Campo obrigatório");
      return errors;
    },
    hasMultispectralCameraErrors() {
      const errors = [];
      if (!this.$v.form.hasMultispectralCamera.$dirty) return errors;
      !this.$v.form.hasMultispectralCamera.required &&
        errors.push("Campo obrigatório");
      return errors;
    },
    multispectralCameraModelsErrors() {
      const errors = [];
      if (!this.$v.form.multispectralCameraModels.$dirty) return errors;
      !this.$v.form.multispectralCameraModels.required &&
        errors.push("Campo obrigatório");
      return errors;
    },
    hasMandatoryInsuranceErrors() {
      const errors = [];
      if (!this.$v.form.hasMandatoryInsurance.$dirty) return errors;
      !this.$v.form.hasMandatoryInsurance.required &&
        errors.push("Campo obrigatório");
      return errors;
    },
    hasAnacRegisterErrors() {
      const errors = [];
      if (!this.$v.form.hasAnacRegister.$dirty) return errors;
      !this.$v.form.hasAnacRegister.required &&
        errors.push("Campo obrigatório");
      return errors;
    },
    hasAnatelHomologationErrors() {
      const errors = [];
      if (!this.$v.form.hasAnatelHomologation.$dirty) return errors;
      !this.$v.form.hasAnatelHomologation.required &&
        errors.push("Campo obrigatório");
      return errors;
    },
    hasSarpasRegisterOnDeceaErrors() {
      const errors = [];
      if (!this.$v.form.hasSarpasRegisterOnDecea.$dirty) return errors;
      !this.$v.form.hasSarpasRegisterOnDecea.required &&
        errors.push("Campo obrigatório");
      return errors;
    },
    sarpasRegisterNumberOnDeceaErrors() {
      const errors = [];
      if (!this.$v.form.sarpasRegisterNumberOnDecea.$dirty) return errors;
      !this.$v.form.sarpasRegisterNumberOnDecea.required &&
        errors.push("Campo obrigatório");
      return errors;
    },
    hasMappaRegisterErrors() {
      const errors = [];
      if (!this.$v.form.hasMappaRegister.$dirty) return errors;
      !this.$v.form.hasMappaRegister.required &&
        errors.push("Campo obrigatório");
      return errors;
    },
    districtErrors() {
      const errors = [];
      if (!this.$v.form.district.$dirty) return errors;
      !this.$v.form.district.required && errors.push("Campo obrigatório");
      return errors;
    },
    addressNumberErrors() {
      const errors = [];
      if (!this.$v.form.addressNumber.$dirty) return errors;
      !this.$v.form.addressNumber.required && errors.push("Campo obrigatório");
      return errors;
    },
    maritalStatusErrors() {
      const errors = [];
      if (!this.$v.form.maritalStatus.$dirty) return errors;
      !this.$v.form.maritalStatus.required && errors.push("Campo obrigatório");
      return errors;
    },
  },
  watch: {
    strZipCode(newValue) {
      const unmaskedStrZipCode = unmask(newValue, this.cpfMask);
      if (eq(unmaskedStrZipCode.length, 8)) {
        this.getAddress();
      }
    },
  },
  mounted() {
    this.$appMng.setTitle("Serviços");

    listFlightProvider(this.$apiAuth.getAuthToken()).then((resp) => {
      this.form.name = resp.data.data[0].str_name;
      this.form.cpf = resp.data.data[0].str_cpf;
      let birthdate = moment(resp.data.data[0].dh_birthdate);
      this.form.birthdate = birthdate.format("DD/MM/YYYY");
      this.form.corporateEmail = resp.data.data[0].str_corporate_email;
      this.form.corporateEmailConfirm = resp.data.data[0].str_corporate_email;
      this.form.phoneNumber = new PhoneNumber(
        resp.data.data[0].str_phone_number,
        "BR"
      );
      this.form.phoneNumberConfirm = new PhoneNumber(
        resp.data.data[0].str_phone_number,
        "BR"
      );
      this.form.companyName = resp.data.data[0].str_company_name;
      this.form.cnpj = resp.data.data[0].str_cnpj;
      this.form.companyLegalRepresentativeName =
        resp.data.data[0].str_company_legal_representative_name;
      this.form.companySite = resp.data.data[0].str_company_site;
      this.strZipCode = resp.data.data[0].str_cep;
      this.form.state = resp.data.data[0].str_state;
      this.form.city = resp.data.data[0].str_city;
      this.form.street = resp.data.data[0].str_street;
      this.form.complement = resp.data.data[0].str_complement;
      this.form.aerialMappingExperience =
        resp.data.data[0].str_aerial_mapping_experience;
      this.form.mappingSectors = resp.data.data[0].lst_mapping_sectors;
      this.form.hasTechinicalQualificationSurveyingTopography =
        resp.data.data[0].bl_has_technical_qualification_surveying_topography;
      this.form.issueArt = resp.data.data[0].bl_issue_art;
      this.form.hasGcpExperience = resp.data.data[0].bl_has_gcp_experience;
      this.form.hasGpsRtk = resp.data.data[0].bl_has_gps_rtk;
      this.form.hasFixedWingsDrone = resp.data.data[0].bl_has_fixed_wings_drone;
      this.form.fixedWingsDroneModels =
        resp.data.data[0].str_fixed_wings_drone_models;
      this.form.hasMultirotorDrone = resp.data.data[0].bl_has_multirotor_drone;
      this.form.multirotorDroneModels =
        resp.data.data[0].lst_multirotor_drone_models;
      this.form.hasMultispectralCamera =
        resp.data.data[0].bl_has_multispectral_camera;
      this.form.multispectralCameraModels =
        resp.data.data[0].str_multispectral_camera_models;
      this.form.hasMandatoryInsurance =
        resp.data.data[0].bl_has_mandatory_insurance;
      this.form.hasAnacRegister = resp.data.data[0].bl_has_anac_register;
      this.form.hasAnatelHomologation =
        resp.data.data[0].bl_has_anatel_homologation;
      this.form.hasSarpasRegisterOnDecea =
        resp.data.data[0].bl_has_sarpas_register_on_decea;
      this.form.sarpasRegisterNumberOnDecea =
        resp.data.data[0].str_sarpas_register_number_on_decea;
      this.form.hasMappaRegister = resp.data.data[0].bl_has_mappa_register;
      this.form.district = resp.data.data[0].str_district;
      this.form.addressNumber = resp.data.data[0].str_address_number;
      this.form.maritalStatus = resp.data.data[0].str_marital_status;
      this.id = resp.data.data[0].id_flight_provider;
      this.status = resp.data.data[0].ab_subscription_status;
      this.cd_document = resp.data.data[0].cd_document;
      this.cd_key_signer = resp.data.data[0].cd_key_signer;

      if (this.status === "WAITING_SIGNATURES") {
        this.setName(this.form.name);
        this.setEmail(this.form.corporateEmail);
        this.setBirthDate(resp.data.data[0].dh_birthdate);
        this.setCpf(this.form.cpf);
        this.setUuidDoc(this.cd_document);
        this.setKeySigner(this.cd_key_signer);
        this.$router.push("/app/accreditation-signature");
      }

      if (this.status === "SIGNED") {
        this.$nextTick().then(() => {
          this.tab = "tab-orders";
        });
      }
    });
  },
};
</script>

<style scoped lang="scss">
@import "../../sass/mixins";

.stepper-width {
  min-width: 100%;
}

.container-width {
  min-width: 80%;
  max-width: 80%;
  @include display-md-and-down {
    min-width: 100%;
    max-width: 100%;
    padding: 0px;
  }
}

.head {
  @include display-md-and-down {
    padding-top: 20px;
    margin-left: 20px;
  }
}

.politics {
  text-align: left;
  word-wrap: break-word;
  white-space: normal;
  padding: 0px;
}

.doc {
  width: 100% !important;
  height: 100% !important;
}

#dialog-term {
    height: 600px !important;
    width: 550px !important;
}
</style>
